// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var IApplicationsStatus;
(function (IApplicationsStatus) {
    IApplicationsStatus["PENDING"] = "PENDING";
    IApplicationsStatus["ACCEPTED"] = "ACCEPTED";
    IApplicationsStatus["REJECTED"] = "REJECTED";
})(IApplicationsStatus || (IApplicationsStatus = {}));
export var RejectReason;
(function (RejectReason) {
    RejectReason["INSUFFICIENT_INFORMATION"] = "insufficient-information";
    RejectReason["NO_VOTER"] = "no-matching-voter";
    RejectReason["ALREADY_APPROVED"] = "voter-already-approved";
    RejectReason["OTHER"] = "other";
})(RejectReason || (RejectReason = {}));
export var ApplicationsError;
(function (ApplicationsError) {
    ApplicationsError["APPROVED_VOTER"] = "Approved_Voter";
})(ApplicationsError || (ApplicationsError = {}));
